<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();
</script>

<template>
    <div class="space-y-4">
        <div class="space-y-1">
            <h3 class="text-sm font-semibold text-gray-900">Partner permissions</h3>
            <p class="text-sm text-gray-500">Control what partners can see and do on the portal.</p>
        </div>

        <toggle
            size="medium"
            title="Hide referrals contact information"
            name="portal_general_hide_partner_contact_info"
            :model-value="!!portalContentAndDesignStore.portalLayoutSettings.portal_general_hide_partner_contact_info"
            @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_general_hide_partner_contact_info = $event"
        >
            <template #description>
                Partners will not see referrals contact information on the portal.
            </template>
        </toggle>

        <toggle
            size="medium"
            title="Hide signup events in referral activity"
            name="portal_general_hide_signup_events_in_referral_activity"
            :model-value="!!portalContentAndDesignStore.portalLayoutSettings.portal_general_hide_signup_events_in_referral_activity"
            @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_general_hide_signup_events_in_referral_activity = $event"
        >
            <template #description>
                Signup events will be hidden from the referral activity list.
            </template>
        </toggle>

        <toggle
            size="medium"
            title="Disable option to create new referral links"
            name="portal_general_disable_referral_link_generation"
            :model-value="!!portalContentAndDesignStore.portalLayoutSettings.portal_general_disable_referral_link_generation"
            @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_general_disable_referral_link_generation = $event"
        >
            <template #description>
                Partners will not be able to create new referral links.
            </template>
        </toggle>

        <toggle
            size="medium"
            title="Disable option to edit referral links"
            name="portal_general_disable_referral_link_modification"
            :model-value="!!portalContentAndDesignStore.portalLayoutSettings.portal_general_disable_referral_link_modification"
            @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_general_disable_referral_link_modification = $event"
        >
            <template #description>
                Partners will not be able to edit referral links.
            </template>
        </toggle>

        <toggle
            size="medium"
            title="Enable partners to create customers"
            name="portal_general_enable_partners_to_create_customers"
            :model-value="!!portalContentAndDesignStore.portalLayoutSettings.portal_general_enable_partners_to_create_customers"
            @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_general_enable_partners_to_create_customers = $event"
        >
            <template #description>
                Partners will be able to create customers that they brought.
            </template>
        </toggle>

        <toggle
            size="medium"
            title="Show current commission on dashboard"
            name="portal_general_show_current_commission_on_dashboard"
            :model-value="!!portalContentAndDesignStore.portalLayoutSettings.portal_general_show_current_commission_on_dashboard"
            @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_general_show_current_commission_on_dashboard = $event"
        >
            <template #description>
                Partners will see their current commission rate on the dashboard.
            </template>
        </toggle>

        <toggle
            size="medium"
            title="Hide commission period"
            name="portal_general_hide_commission_period"
            :model-value="!!portalContentAndDesignStore.portalLayoutSettings.portal_general_hide_commission_period"
            @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_general_hide_commission_period = $event"
        >
            <template #description>
                Hide the commission period (e.g. "for lifetime") across the portal and program pages.
            </template>
        </toggle>

        <toggle
            size="medium"
            title="Disable link tracking options"
            name="portal_general_disable_link_tracking"
            :model-value="!!portalContentAndDesignStore.portalLayoutSettings.portal_general_disable_link_tracking"
            @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_general_disable_link_tracking = $event"
        >
            <template #description>
                Partners will not see link sharing, clicks and signups tracking.
            </template>
        </toggle>
    </div>

    <div class="space-y-4 border-t border-gray-200 pt-4 mt-4">
        <div class="space-y-1">
            <h3 class="text-sm font-semibold text-gray-900">Contact information</h3>
            <p class="text-sm text-gray-500">Shown in the portal footer.</p>
        </div>

        <text-field
            label="Email address"
            name="portal_dashboard_contact_info_email"
            type="text"
            placeholder="Enter email address or leave blank"
            v-model="portalContentAndDesignStore.portalLayoutSettings.portal_dashboard_contact_info_email"
        />

        <text-field
            label="Phone number"
            name="portal_dashboard_contact_info_phone"
            type="text"
            placeholder="Enter phone number or leave blank"
            v-model="portalContentAndDesignStore.portalLayoutSettings.portal_dashboard_contact_info_phone"
        />
    </div>
</template>
